import Vue from 'vue'
import Vuex from 'vuex'

import search from './search'
import glossary from './glossary'
import dialog from './dialog'

Vue.use(Vuex)

export default new Vuex.Store({
  getters: {
    query: state => state.route.query
  },
  modules: {
    search: search,
    glossary: glossary,
    dialog: dialog
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js